import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Textarea } from "./ui/textarea";
import { Trash2 } from "lucide-react";

export default function CommentsDialog({ projectId, entityType, entityId, entityLabel, open, onClose }) {
  const [comments, setComments] = useState([]);
  const [text, setText] = useState("");

  const load = useCallback(() => {
    if (!entityId) return;
    api.get(`/projects/${projectId}/comments`, { params: { entityType, entityId } })
      .then((r) => setComments(r.data)).catch(() => {});
  }, [projectId, entityType, entityId]);
  useEffect(() => { if (open) load(); }, [open, load]);

  const post = async () => {
    if (!text.trim()) return;
    try {
      await api.post(`/projects/${projectId}/comments`, { entityType, entityId, text: text.trim() });
      setText(""); load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-none max-w-lg max-h-[80vh] flex flex-col">
        <DialogHeader><DialogTitle className="font-display">Comments — {entityLabel}</DialogTitle></DialogHeader>
        <div data-testid="comments-list" className="flex-1 overflow-y-auto space-y-3 min-h-[120px]">
          {comments.length === 0 && <p className="text-xs text-muted-foreground">No comments yet — start the thread.</p>}
          {comments.map((c) => (
            <div key={c.id} data-testid="comment-item" className="border-l-2 border-[#1E6FE8] pl-3">
              <div className="flex justify-between items-center">
                <span className="text-xs font-semibold">{c.authorName}</span>
                <span className="text-[10px] text-muted-foreground">{(c.createdAt || "").slice(0, 16).replace("T", " ")}
                  <button onClick={async () => { await api.delete(`/projects/${projectId}/comments/${c.id}`); load(); }} className="ml-2 hover:text-red-600"><Trash2 className="h-3 w-3 inline" /></button>
                </span>
              </div>
              <p className="text-sm mt-0.5 whitespace-pre-wrap">{c.text}</p>
            </div>
          ))}
        </div>
        <Textarea data-testid="comment-input" rows={2} placeholder="Write a comment…" value={text} onChange={(e) => setText(e.target.value)} />
        <Button data-testid="post-comment-btn" className="rounded-none" onClick={post} disabled={!text.trim()}>Post comment</Button>
      </DialogContent>
    </Dialog>
  );
}
